enum PaymentFrequency {
  ONE_TIME = 'oneTime',
  MONTHLY = 'month',
}

export default PaymentFrequency;
